import { Popover } from "antd";
import React from "react";
import isEmpty from "../../../../../../../core/helpers/isEmpty";
const IntegrationPopover = ({ data }) => {
    const firstKey = Object.keys(data || {})[0];
    const headers = firstKey ? Object.keys(data[firstKey] || {}) : [];
    const content = (React.createElement("div", { style: { minWidth: "500px" }, className: "currentFinancialRatingBox system-integration-table" },
        React.createElement("h6", { className: "font-weight-bold text-center text-capitalize", style: { marginTop: "0px", borderBottom: "3px dotted grey", paddingBlock: "10px", marginBottom: "20px" } }, "System Integrations"),
        isEmpty(data) ? React.createElement("div", { className: "mb-2", style: { marginTop: "-10px" } }, "No Data") : React.createElement("table", { className: "table table-bordered table-sm mb-0 text-left" },
            React.createElement("thead", { className: "table-light", style: { backgroundColor: "rgba(0,0,0,0.1)", textTransform: "capitalize" } },
                React.createElement("tr", null,
                    React.createElement("th", null, "Name"),
                    headers.map((item) => (React.createElement("th", { key: item },
                        item,
                        (item === null || item === void 0 ? void 0 : item.includes("complet")) ? " (%)" : ""))))),
            React.createElement("tbody", null, Object.keys(data).map((name) => (React.createElement("tr", { key: name },
                React.createElement("td", null, name),
                headers.map((h) => {
                    var _a;
                    return (React.createElement("td", { key: h },
                        Math.round((_a = data[name]) === null || _a === void 0 ? void 0 : _a[h]),
                        (h === null || h === void 0 ? void 0 : h.includes("complet")) ? `%` : ""));
                }))))))));
    return (React.createElement(Popover, { content: content, trigger: "hover", overlayClassName: "category-popover-container" },
        React.createElement("span", { className: "font-weight-bold cursor-pointer" }, "System Integrations")));
};
export default IntegrationPopover;
